// =============================================================================
// VINUM - PageTransition Component
// Simple wrapper that applies fade-in animation on mount
// =============================================================================

import React from 'react';
import { cn } from '@/lib/cn';

interface PageTransitionProps {
  children: React.ReactNode;
  className?: string;
}

export const PageTransition: React.FC<PageTransitionProps> = ({ children, className }) => (
  <div className={cn('animate-fade-in', className)}>
    {children}
  </div>
);

PageTransition.displayName = 'PageTransition';
